import React from 'react';
import { Box, Button, Grid, Paper } from '@material-ui/core';
import styled from 'styled-components';

import { ErrorWarning } from '@styled-icons/remix-fill';

const StyledPaper = styled(Paper)`
  padding: 3rem;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  border: 2px solid #000;
  box-shadow: ${(p) => p.theme.shadows[5]};
`;

const Icon = styled(ErrorWarning)`
  width: 2rem;
  height: 2rem;
  color: blue;
`;

const defaultHeader = 'Importante';
const defaultContent = 'Contenido';
const defaultButtons = [
  { type: 'exit', variant: 'contained', color: 'secondary', text: 'Salir' },
  { type: 'accept', variant: 'contained', color: 'primary', text: 'Aceptar' },
];

const handleExit = () => {};
const handleAccept = () => {};

const defaultHandlers = {
  handleExit,
  handleAccept,
};

function InformationModal({ handlers = defaultHandlers, modalProps = {} }) {
  const {
    header = defaultHeader,
    content = defaultContent,
    buttons = defaultButtons,
  } = modalProps;

  return (
    <StyledPaper elevation={3}>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="stretch"
        spacing={4}
      >
        <Grid item>
          <Icon />
        </Grid>
        <Grid item>{header}</Grid>
        <Grid item>{content}</Grid>
        <Grid item>
          <Box display="flex" justifyContent="space-between">
            {buttons.map((button) => {
              return (
                <Button variant={button.variant} color={button.color}>
                  {button.text}
                </Button>
              );
            })}
          </Box>
        </Grid>
      </Grid>
    </StyledPaper>
  );
}

export default InformationModal;
